import * as React from 'react';
import { SvgIcon as MuiSvgIcon, SvgIconProps, styled } from '@mui/material';

const SvgIcon = styled(MuiSvgIcon, {
    name: 'JobfactorIcon',
    shouldForwardProp: (prop) => prop !== 'fill'
})<SvgIconProps>(() => ({
    fill: 'currentColor',
}));

SvgIcon.defaultProps = {
    viewBox: '0 0 20 20',
    focusable: 'false',
    'aria-hidden': 'true'
};

const Edit: React.FunctionComponent<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M17.5 18.3359H2.5C2.15833 18.3359 1.875 18.0526 1.875 17.7109C1.875 17.3693 2.15833 17.0859 2.5 17.0859H17.5C17.8417 17.0859 18.125 17.3693 18.125 17.7109C18.125 18.0526 17.8417 18.3359 17.5 18.3359Z" />
            <path d="M15.8495 2.90005C14.2328 1.28338 12.6495 1.24172 10.9912 2.90005L9.98283 3.90838C9.89949 3.99172 9.86616 4.12505 9.89949 4.24172C10.5328 6.45005 12.2995 8.21672 14.5078 8.85005C14.5412 8.85838 14.5745 8.86672 14.6078 8.86672C14.6995 8.86672 14.7828 8.83338 14.8495 8.76672L15.8495 7.75838C16.6745 6.94172 17.0745 6.15005 17.0745 5.35005C17.0828 4.52505 16.6828 3.72505 15.8495 2.90005Z" />
            <path d="M13.007 9.60573C12.7653 9.48906 12.532 9.3724 12.307 9.23906C12.1236 9.13073 11.9486 9.01406 11.7736 8.88906C11.632 8.7974 11.4653 8.66406 11.307 8.53073C11.2903 8.5224 11.232 8.4724 11.1653 8.40573C10.8903 8.1724 10.582 7.8724 10.307 7.53906C10.282 7.5224 10.2403 7.46406 10.182 7.38906C10.0986 7.28906 9.95697 7.1224 9.83197 6.93073C9.73197 6.80573 9.6153 6.6224 9.50697 6.43906C9.37364 6.21406 9.25697 5.98906 9.1403 5.75573C8.98734 5.42795 8.55713 5.33057 8.30135 5.58635L3.6153 10.2724C3.50697 10.3807 3.40697 10.5891 3.38197 10.7307L2.93197 13.9224C2.84864 14.4891 3.00697 15.0224 3.35697 15.3807C3.65697 15.6724 4.07364 15.8307 4.52364 15.8307C4.62364 15.8307 4.72364 15.8224 4.82364 15.8057L8.02364 15.3557C8.17364 15.3307 8.38197 15.2307 8.48197 15.1224L13.1758 10.4286C13.4264 10.178 13.3322 9.74668 13.007 9.60573Z" />
        </SvgIcon>
    );
};

interface EditIconProps {
    fontSize?: any;
}

const EditIcon = ({ fontSize }: EditIconProps) => {
    if (fontSize) return <Edit fontSize={fontSize} />;
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"
                fill="#05668D"
            />
            <path
                d="M19.0186 3.48016C17.0786 1.54016 15.1786 1.49016 13.1886 3.48016L11.9786 4.69016C11.8786 4.79016 11.8386 4.95016 11.8786 5.09016C12.6386 7.74016 14.7586 9.86016 17.4086 10.6202C17.4486 10.6302 17.4886 10.6402 17.5286 10.6402C17.6386 10.6402 17.7386 10.6002 17.8186 10.5202L19.0186 9.31016C20.0086 8.33016 20.4886 7.38016 20.4886 6.42016C20.4986 5.43016 20.0186 4.47016 19.0186 3.48016Z"
                fill="#05668D"
            />
            <path
                d="M15.6084 11.5298C15.3184 11.3898 15.0384 11.2498 14.7684 11.0898C14.5484 10.9598 14.3384 10.8198 14.1284 10.6698C13.9584 10.5598 13.7584 10.3998 13.5684 10.2398C13.5484 10.2298 13.4784 10.1698 13.3984 10.0898C13.0684 9.8098 12.6984 9.4498 12.3684 9.0498C12.3384 9.0298 12.2884 8.9598 12.2184 8.8698C12.1184 8.7498 11.9484 8.5498 11.7984 8.3198C11.6784 8.1698 11.5384 7.9498 11.4084 7.7298C11.2484 7.4598 11.1084 7.1898 10.9684 6.9098C10.9472 6.86441 10.9267 6.81924 10.9068 6.77434C10.7592 6.44102 10.3246 6.34358 10.0668 6.60133L4.33837 12.3298C4.20837 12.4598 4.08837 12.7098 4.05837 12.8798L3.51837 16.7098C3.41837 17.3898 3.60837 18.0298 4.02837 18.4598C4.38837 18.8098 4.88837 18.9998 5.42837 18.9998C5.54837 18.9998 5.66837 18.9898 5.78837 18.9698L9.62837 18.4298C9.80837 18.3998 10.0584 18.2798 10.1784 18.1498L15.8997 12.4285C16.1592 12.1689 16.0613 11.7235 15.7237 11.5794C15.6857 11.5632 15.6473 11.5467 15.6084 11.5298Z"
                fill="#05668D"
            />
        </svg>
    );
};

export default EditIcon;
